import { CandybarItemConfigType, CandybarItemOptionType, CandybarItemType } from "../components/checkout/Candybar/types";

// @todo These methods are pretty similar and confusing... refactor needed.

export function getCandybarItemPriceWithSelectedOptions(item: CandybarItemType, unitConfig): number {
    return getCandybarItemPriceWithConfigsState(item, unitConfig);
}

export function getCandybarItemPriceWithConfigs(state, itemId, itemConfigs) {
    const item = state.entities.candybarItems[itemId];
    const isPaymentParam = Array.isArray(itemConfigs);
    let result = 0;

    if (isPaymentParam) {
        result += getCandybarItemPriceWithConfigsParam(item, itemConfigs);
    } else {
        result += getCandybarItemPriceWithConfigsState(item, itemConfigs);
    }

    return result;
}

function getCandybarItemPriceWithConfigsParam(item:CandybarItemType, itemConfigs) {
    let result = item.price;

    itemConfigs.forEach(unitConfig => {
        const config = findItemConfig(item, unitConfig.id);

        if (!config) {
            return;
        }

        config.options.forEach(option => {
            if (unitConfig.value.indexOf(option.id) > -1) {
                result += option.price;
            }
        });
    });

    return result;
}

function getCandybarItemPriceWithConfigsState(item:CandybarItemType, itemConfigs:Array<CandybarItemConfigType>) {
    let result = item.price;

    Object.keys(itemConfigs).forEach(unitConfigId => {
        if ('comments' === unitConfigId) {
            return;
        }

        const config = findItemConfig(item, unitConfigId);

        if (!config) {
            return;
        }

        config.options.forEach(option => {
            if (itemConfigs[unitConfigId].indexOf(option.id) > -1) {
                result += option.price;
            }
        })
    });

    return result;
}

function findItemConfig(item:CandybarItemType, configId:any): CandybarItemConfigType | null {
    configId = String(configId);

    const result = item.configs.reduce((carry:CandybarItemConfigType | null, config:CandybarItemConfigType) => {
        if (config.id === configId) {
            return config;
        }

        const subConfigs = config.options.reduce((carry:Array<CandybarItemConfigType>, option:CandybarItemOptionType) => carry.concat(option.subConfigs.filter(subConfig => subConfig.id === configId)), []);
        if (subConfigs.length) {
            return subConfigs[0];
        }

        return carry;
    }, null);

    return result;
}
